import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from "rxjs";

import { AssignmentGetModel } from '@app/models/failure/problem.model';
import { TeamAttendanceModel } from 'src/app/models/fmsmodel/fault.model';
import { AssignmentScheduleModel } from '@app/models/failure/assignment.model';

@Injectable({ providedIn: 'root' })
export class AssignmentService {

  private apiUrl = `${environment.apiUrl}/api/assignment/`;

  constructor(private httpClient: HttpClient) { }

  public getAssignmentByFaultCode(searchValue: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.apiUrl}/searchAssignmentMobile`, searchValue,{});
  }

  public postAssignmentMobile(assignment: any) {
    return this.httpClient.post(`${this.apiUrl}/updateAssignmentMobile/`, assignment, {});
  }

  public postAssignment(assinmentData: any) {
    return this.httpClient.post(`${this.apiUrl}`, assinmentData, {});
  }

  public postAssignmentTeam(teamModel: any): Observable<TeamAttendanceModel> {
    return this.httpClient.post<TeamAttendanceModel>(`${this.apiUrl}/assignTeam/`, teamModel, {});
  }

  public getAssignmentByFaultId(problemId: number): Observable<AssignmentGetModel[]> {
    return this.httpClient.get<AssignmentGetModel[]>(`${this.apiUrl}${problemId}`, {});
  }

  public getTeamRelatedschedule(teamId: string): Observable<AssignmentScheduleModel[]> {
    return this.httpClient.get<AssignmentScheduleModel[]>(`${this.apiUrl}/teamSchedule/${teamId}`, {});
  }
  public getPersonRelatedschedule(personId: number): Observable<AssignmentScheduleModel[]> {
    return this.httpClient.get<AssignmentScheduleModel[]>(`${this.apiUrl}/personSchedule/${personId}`, {});
  }

}
